<template>
  <div style="width: 100%;height: 100%;cursor: pointer;" @click="clickHandler"
       :style="{backgroundColor:option.attribute.bgColor,color:option.attribute.textColor,borderRadius:option.attribute.radius+'px',}">
    <div style="display: inline-block;vertical-align: middle;"
         :style="{width: option.attribute.iconSize + 'px',height: option.attribute.iconSize + 'px',marginLeft: (option.attribute.iconBoxLeft || 50) + 'px'}">
      <img style="width: 100%;height: 100%" :src="option.attribute.icon? fileUrl + option.attribute.icon:require('@/assets/logo.png')"/>
    </div>
    <div style="display: inline-block;margin-left: 14px;vertical-align: middle"
         :style="{lineHeight:height+'px',fontSize:option.attribute.fontSize+'px'}">{{option.attribute.title}}</div>
  </div>
</template>

<script>
import {fileUrl} from '/env'
export default {
  name: "cpt-link-card",
  props: ['option','height','current'],
  data() {
    return {
      fileUrl
    }
  },
  methods:{
    clickHandler(){
      this.$emit("clickHandler",this.option.interaction)
    }
  }
}
</script>

<style scoped>

</style>
